<template>
    <div :class="'col-md-' + validConfig.col">
        <label>{{ validConfig.holder }}:</label>

        <div class="form-group">
            <div class="input-group">

                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i
                            v-if="isError.bool"
                            class="far fa-calendar-alt"
                        ></i>

                        <i
                            v-else
                            @click="isErrormsg(isError)"
                            class="fa fa-exclamation-triangle text-danger skew-shake-y"
                            style="cursor:pointer"
                        ></i>
                    </span>
                </div>

                <input
                    type="month"
                    :id="validConfig.id"
                    :value="modelValue ?? ''"
                    @input="onMonthChange"
                    class="form-control"
                    :class="isError.class"
                    :placeholder="validConfig.holder"
                />

            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { reactive, toRefs, watchEffect } from "vue";
import validate from "../../../composable/useValidate";
import messages from "../../../composable/useMessages";

const { longitud } = validate();
const { validateNotification } = messages();

const props = defineProps<{
    modelValue: string | null,
    validConfig: {
        value?: string | null,
        validate: boolean,
        name: string,
        message: string,
        col: number,
        min: number,
        max: number,
        empaty: number,
        holder: string,
        id: string
    }
}>();

const emit = defineEmits<{
    (e: "updateStatus", name: string, status: boolean): void
    (e: "updateValue", value: string, name: string): void
}>();

const { validConfig, modelValue } = toRefs(props);

let isError = reactive({
    validate: false,
    class: "",
    required: validConfig.value.message,
    bool: true
});

const isErrormsg = (dto: object) => {
    validateNotification(dto);
};

const onMonthChange = (event: Event) => {
    const value = (event.target as HTMLInputElement).value;

    emit(
        "updateValue",
        value,
        validConfig.value.name
    );
};

watchEffect(() => {
    isError = longitud(
        modelValue.value ?? "",
        validConfig.value.empaty,
        validConfig.value.min,
        validConfig.value.max,
        isError.required
    );

    emit(
        "updateStatus",
        validConfig.value.name,
        isError.validate
    );
});
</script>